module.exports = __webpack_public_path__ + "img/ok.337b47d9.svg";